export default {
      id: "resume-journey-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#resume-journey",
      toString: function () {
        return this.url;
      }
    }